export const useGetTheme = (user?: string) => {
  const themes = ['egis', 'lukoil', 'base'];
  if (user && themes.includes(user)) return user;
  return 'base';
};
